import { usePriceComparison } from "@/contexts/classified";
import { InvestmentValueMapIcon } from "@/components/Sections/PriceComparison/constants";
export const useInvestmentValues = () => {
    const { investmentValues } = usePriceComparison();
    const allInvestmentValues = investmentValues === null || investmentValues === void 0 ? void 0 : investmentValues.reduce((acc, group) => {
        return acc.concat(group.values);
    }, []);
    const investmentValuesWithIcon = allInvestmentValues === null || allInvestmentValues === void 0 ? void 0 : allInvestmentValues.map((investmentValue) => (Object.assign(Object.assign({}, investmentValue), { icon: InvestmentValueMapIcon[investmentValue.key] })));
    return {
        investmentValues: investmentValuesWithIcon,
    };
};
